<header class="header" [class.header--menu-open]="isMobileMenuOpen">

  <!-- Mobile: Barra de busca expandível -->
  <div class="mobile-search-container" [class.open]="isMobileSearchOpen">
    <div class="mobile-search-bar">
      <span class="search-icon clickable mdn-Icon-lupa" (click)="onSearchIconClick()" aria-hidden="true"></span>
      <input type="text"
             [placeholder]="'components.header.searchPlaceholder' | i18n"
             class="mobile-search-input"
             [(ngModel)]="searchTerm"
             (keyup.enter)="onSearchSubmit($event)"
             (input)="onSearchInput($event)" />
      @if (isMobileSearchOpen) {
        <button class="close-search-btn" (click)="onSearchClick()">
          <span class="mdn-Icon-fechar" aria-hidden="true"></span>
        </button>
      }
    </div>
  </div>

  <div class="header-top">
    <div class="header-top-left">
      @if (showExternalPanelBackButton) {
        <button
          type="button"
          class="external-panel-back-btn"
          (click)="openExternalChannelExitModal()"
          [attr.aria-label]="'components.header.externalPanelBack' | i18n"
        >
          <span class="external-panel-back-btn__icon mdn-Icon-esquerda mdn-Icon--sm" aria-hidden="true"></span>
          <span class="external-panel-back-btn__text">{{ 'components.header.externalPanelBack' | i18n }}</span>
        </button>
      }

      @if (showExternalPanelBackButton && isAuthenticated && !isCnpjLoading) {
        <span class="separator" aria-hidden="true">|</span>
      }

      @if (isAuthenticated && !isCnpjLoading && isComboSueNetsmsMode) {
        <umkt-combo-selector
          [externalAccess]="externalAccess"
          [selectedMobileDocument]="selectedCnpj"
          [selectedContractId]="selectedContractId"
          [selectedSegment]="selectedSegment"
          [isLoading]="isSegmentSelectionLoading"
          (mobileChange)="onCnpjChange($event)"
          (contractChange)="onContractChange($event.customerAccountId)"
          (showAllProducts)="router.navigate(['/segment-selection'])"
        ></umkt-combo-selector>
      }

      @if (isAuthenticated && !isCnpjLoading && !isComboSueNetsmsMode) {
        <umkt-cnpj-selector
          [cnpjList]="cnpjList"
          [contractList]="contractList"
          [selectedCnpj]="selectedCnpj"
          [selectedContractId]="selectedContractId"
          [companyName]="userCompanyName"
          [fallbackText]="activeTopNavItem"
          [isFixaMode]="isFixaMode"
          [isLoading]="isSegmentSelectionLoading"
          (cnpjChange)="onCnpjChange($event)"
          (contractChange)="onContractChange($event)"
        ></umkt-cnpj-selector>
      }
    </div>

    <div class="header-top-right">
      @if (showLocationInHeader) {
        <button
          type="button"
          class="location-trigger"
          (click)="openLocationModal()"
          [title]="'components.header.locationTrigger' | i18n"
          [attr.aria-label]="'components.header.locationTrigger' | i18n"
        >
          <span class="location-icon mdn-Icon-localizacao mdn-Icon--sm" aria-hidden="true"></span>
          <span class="location-text">
            @if (locationDisplayText$ | async; as info) {
              @if (info.hasLocation) {
                {{ info.cityState }}{{ info.cepPart }}
              } @else {
                {{ 'components.header.locationTrigger' | i18n }}
              }
            }
          </span>
        </button>
      }

      <button
        class="icon-btn theme-btn"
        [title]="'components.header.accessibility.theme' | i18n"
        [attr.aria-label]="'components.header.accessibility.theme' | i18n"
        (click)="testToggleTheme()"
      >
        <span class="mdn-Icon-circulo-metade-preenchido mdn-Icon--sm" aria-hidden="true"></span>
      </button>

      <div class="text-size-controls">
        <button
          class="text-size-btn"
          [title]="'components.header.accessibility.decrease' | i18n"
          [attr.aria-label]="'components.header.accessibility.decrease' | i18n"
          (click)="handleFontSize('-')"
        >
          <span class="mdn-Icon-tamanho-diminuir mdn-Icon--sm" aria-hidden="true"></span>
        </button>
        <button
          class="text-size-btn"
          [title]="'components.header.accessibility.increase' | i18n"
          [attr.aria-label]="'components.header.accessibility.increase' | i18n"
          (click)="handleFontSize('+')"
        >
          <span class="mdn-Icon-tamanho-aumentar mdn-Icon--sm" aria-hidden="true"></span>
        </button>
      </div>

      <div class="language-selector">
        <button
          class="language-btn"
          [class.active]="isLanguageMenuOpen"
          (click)="toggleLanguageMenu()"
        >
          <img [src]="selectedLanguage.flag" [alt]="selectedLanguage.name" class="flag-icon" />
          <span class="mdn-Icon-baixo mdn-Icon--sm" aria-hidden="true"></span>
        </button>

        <div class="language-dropdown" [class.open]="isLanguageMenuOpen">
          @for (lang of languages; track lang.code) {
            <button
              class="language-option"
              [class.active]="selectedLanguage.code === lang.code"
              (click)="selectLanguage(lang.code)"
            >
              <img [src]="lang.flag" [alt]="lang.alt" class="flag-icon" />
              <span class="language-name">{{ lang.name }}</span>
            </button>
          }
        </div>
      </div>

      @if (isAuthenticated && !isOnlyIndicationActive) {
        <button
          type="button"
          class="logout-btn"
          (click)="onLogoutClick()"
          [attr.aria-label]="'components.header.logout' | i18n"
        >
          <span class="logout-icon mdn-Icon-sair mdn-Icon--sm" aria-hidden="true"></span>
          <span class="logout-text">{{ 'components.header.logout' | i18n }}</span>
        </button>
      }
    </div>
  </div>

  <!-- Mobile simple header (Figma Home - 1.1): Minha Conta + logout (ícone Mondrian, sem botão) -->
  @if (!isOnlyIndicationActive) {
    <div class="header-main header-main--mobile mobile-only">
      @if (isMceExternalFlow) {
        <div class="logo" (click)="onLogoClick()">
          <img
            [src]="mceHeaderLogoUrl"
            alt="Minha Claro Empresas"
            class="logo-image logo-image--light"
          />
          <img
            [src]="mceHeaderLogoInverseUrl"
            alt="Minha Claro Empresas"
            class="logo-image logo-image--dark"
          />
        </div>
      } @else {
        <button
          type="button"
          class="my-account-entry"
          (click)="onMyAccountClick()"
        >
          <span class="my-account-icon mdn-Icon-pessoa-circulo-perfil mdn-Icon--md" aria-hidden="true"></span>
          <span class="my-account-text">{{ 'components.header.nav.myAccount' | i18n }}</span>
        </button>
      }

      @if (isAuthenticated) {
        <span
          class="header-logout-icon mdn-Icon-sair mdn-Icon--md"
          role="button"
          tabindex="0"
          [attr.title]="'components.header.logout' | i18n"
          [attr.aria-label]="'components.header.logout' | i18n"
          (click)="onLogoutClick()"
          (keydown.enter)="onLogoutClick()"
          (keydown.space)="$event.preventDefault(); onLogoutClick()"
        ></span>
      }
    </div>
  }

  <!-- onlyIndication mobile: logo + Indique -->
  @if (isOnlyIndicationActive) {
    <div class="header-main header-main--mobile mobile-only">
      <div class="logo" (click)="onLogoClick()">
        <img [src]="logo$ | async" alt="Claro empresas" class="logo-image logo-image--light" />
        <img [src]="logoInverse$ | async" alt="Claro empresas" class="logo-image logo-image--dark" />
      </div>
      @if (showIndiqueMenu) {
        <a class="nav-link" [class.active]="activeMainNavItem === 'Indique uma PME'" (click)="onIndicationClick()">{{ 'components.header.nav.indicate' | i18n }}</a>
      }
    </div>
  }

  <!-- Desktop main bar -->
  <div class="header-main header-main--desktop desktop-only">
    <div class="header-main-left">
      <div class="logo" (click)="onLogoClick()">
        @if (isMceExternalFlow) {
          <img
            [src]="mceHeaderLogoUrl"
            alt="Minha Claro Empresas"
            class="logo-image logo-image--light"
          />
          <img
            [src]="mceHeaderLogoInverseUrl"
            alt="Minha Claro Empresas"
            class="logo-image logo-image--dark"
          />
        } @else {
          <img
            [src]="logo$ | async"
            alt="Claro empresas"
            class="logo-image logo-image--light"
          />
          <img
            [src]="logoInverse$ | async"
            alt="Claro empresas"
            class="logo-image logo-image--dark"
          />
        }
      </div>

      <nav class="main-navigation">
        @if (!isOnlyIndicationActive) {
          <a class="nav-link" [class.active]="activeMainNavItem === 'Home'" (click)="onHomeClick()">{{ 'components.header.nav.home' | i18n }}</a>
          <a class="nav-link" [class.active]="activeMainNavItem === 'Categorias'" (click)="onCategoriesClick()">{{ 'components.header.nav.categories' | i18n }}</a>
          <a class="nav-link" [class.active]="activeMainNavItem === 'Minha Conta'" (click)="onMyAccountClick()">{{ 'components.header.nav.myAccount' | i18n }}</a>
        }
        @if (showIndiqueMenu) {
          <a class="nav-link" [class.active]="activeMainNavItem === 'Indique uma PME'" (click)="onIndicationClick()">{{ 'components.header.nav.indicate' | i18n }}</a>
        }
        @if (showParceirosMenu && !isOnlyIndicationActive) {
          <a class="nav-link" [class.active]="activeMainNavItem === 'Cadastro de Parceiros'" (click)="onCadastroParceirosClick()">{{ 'components.header.nav.partnerRegistration' | i18n }}</a>
        }
      </nav>
    </div>

    <div class="header-main-right">
      @if (!isOnlyIndicationActive) {
        <div class="search-container">
          <div class="search-bar">
            <input type="text"
                   [placeholder]="'components.header.searchPlaceholder' | i18n"
                   class="search-input"
                   [(ngModel)]="searchTerm"
                   (keyup.enter)="onSearchSubmit($event)"
                   (input)="onSearchInput($event)" />
            @if (searchTerm) {
              <span class="clear-icon clickable mdn-Icon-fechar" (click)="clearSearch()" aria-hidden="true"></span>
            }
            <button (click)="onSearchSubmit($event)" class="search-submit" [title]="'components.header.search' | i18n">
              <span class="search-submit-icon mdn-Icon-lupa" aria-hidden="true"></span>
            </button>
          </div>
        </div>

        <button class="cart-btn" [class.has-items]="(isEmpty$ | async) === false" (click)="toggleCart()" [attr.aria-label]="'components.header.cart' | i18n">
          <span class="cart-icon mdn-Icon-carrinho" aria-hidden="true"></span>
        </button>
      }
    </div>
  </div>

  @if (showLocationInHeader) {
    <umkt-location-modal
      [isOpen]="isLocationModalOpen"
      [mandatory]="isLocationMandatory"
      (modalClose)="closeLocationModal()"
      (locationConfirm)="onLocationConfirm($event)"
    ></umkt-location-modal>
  }

  <umkt-external-channel-exit-modal
    [open]="isExternalChannelExitModalOpen"
    (exit)="confirmExternalChannelExit()"
    (stay)="closeExternalChannelExitModal()"
  ></umkt-external-channel-exit-modal>

  <umkt-modal [isOpen]="isModalOpen" (modalClose)="onModalClose()">
    <div modal-header>
      <h2>{{ 'components.header.accessibilityModal.title' | i18n }}</h2>
    </div>

    <div modal-body>
      <ul class="shortcuts-list">
        <li>
          <span class="checkmark">✓</span>
          <span>{{ 'components.header.accessibilityModal.windows' | i18n }}</span>
        </li>
        <li>
          <span class="checkmark">✓</span>
          <span>{{ 'components.header.accessibilityModal.mac' | i18n }}</span>
        </li>
      </ul>
    </div>

    <div modal-footer>
      <button class="btn-ok" (click)="onModalClose()">{{ 'components.header.accessibilityModal.okButton' | i18n }}</button>
    </div>
  </umkt-modal>

  <umkt-sidebar
    [header]="(sidebarHeader$ | async) || { icon: 'shopping_cart', title: 'Carrinho' }"
    [isOpen]="(isSidebarOpen$ | async) || false"
    (sidebarClose)="onSidebarClose()"
    variant="cart"
    [showTotal]="(isEmpty$ | async) === false"
    [totalLabel]="'components.cart.total' | i18n"
    [totalValue]="(totalCart$ | async)?.amount ?? 0"
    [totalSuffix]="(totalCart$ | async)?.showMonthlySuffix ? ('components.cart.perMonth' | i18n) : ''"
    [showRegistryTotals]="(totalCart$ | async)?.hasRegistryDomain === true"
    [firstMonthTotal]="(totalCart$ | async)?.firstMonth ?? 0"
    [recurringTotal]="(totalCart$ | async)?.monthly ?? 0"
    [showFooterButton]="(isEmpty$ | async) === false"
    [footerButtonText]="'components.cart.checkout' | i18n"
    (footerButtonClick)="onSidebarPrimaryClick()"
  >
  <umkt-cart-page></umkt-cart-page>
  </umkt-sidebar>
</header>
